import { TicketConfig } from "../../../../../../models/partnerResponse";
import { toFixNumber } from "../../../../../../helpers/to-fix-number";
import { BetType } from "../../../../../../models";
import { T } from "../../../../../../constants";
import { KeyValue } from "../key-value";
import { Line } from "../line";

interface MarketProps {
  odd: number;
  roundId: number;
  gameName: string;
  betType: BetType;
  handicap?: number;
  betAmount: number;
  showLine?: boolean;
  marketName: string;
  winAmount?: number;
  isExpress: boolean;
  eventName?: string;
  currencyCode: string;
  possibleWin?: number;
  selectionName?: string;
  showWinAmount?: boolean;
  combinations: Array<number>;
  ticketConfig?: TicketConfig;
  possibleCombinations: number;
}

export const Market: React.FC<MarketProps> = ({
  odd,
  betType,
  roundId,
  gameName,
  handicap,
  betAmount,
  winAmount,
  isExpress,
  eventName,
  marketName,
  possibleWin,
  ticketConfig,
  combinations,
  currencyCode,
  selectionName,
  showLine = true,
  possibleCombinations,
  showWinAmount = false,
}) => {

  return (
    <>
      <KeyValue label={T.GAME} value={gameName} textBold />

      {eventName ? <KeyValue label={eventName} value="" /> : null}

      <KeyValue label={T.ROUND_ID} value={roundId} />

      {ticketConfig?.showMarketNames ? (
        <KeyValue label={`${marketName}`} value={`x${odd}`} />
      ) : null}

      {selectionName ? (
        <KeyValue label={selectionName} value={handicap || ""} />
      ) : null}

      {!isExpress && (
        <KeyValue
          label={T.BET_AMOUNT}
          value={`${toFixNumber(betAmount)} ${currencyCode}`}
        />
      )}

      {possibleWin && ticketConfig?.showExpectedWinPerBet && !winAmount ? (
        <KeyValue
          label={T.POSSIBLE_WIN}
          value={`${toFixNumber(possibleWin)} ${currencyCode}`}
        />
      ) : null}

      {possibleCombinations ? (
        <KeyValue
          label={T.POSSIBLE_COMBINATIONS}
          value={possibleCombinations}
        />
      ) : null}

      {betType === BetType.System ? (
        <KeyValue
          label={T.COMBINATIONS}
          value={combinations.join(",")}
        />
      ) : null}

      {showWinAmount && !isExpress && winAmount ? (
        <KeyValue
          label={T.WINNING_AMOUNT}
          value={`${winAmount} ${currencyCode}`}
        />
      ) : null}

      {showLine && <Line type="dashed" />}
    </>
  );
};
